// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"25b774ee","106":"0a927bf1","395":"8f1d092e","667":"4526a116","799":"cc5c7740"}[chunkId] + ".css";
};